(function() {
	'use strict';
	
	function AgentListItemController($scope) {
		if ($scope.agent === undefined || $scope.agent.imagePath === '' || $scope.agent.imageName === '') {
			$scope.agent.image = '';
		} else {
			$scope.agent.image = "/assets" + $scope.agent.imagePath + "/w_517,h_652,c_zoom/" + $scope.agent.imageName;
		}

		$scope.formatEmail = function(email) {
			if (!email) {
				return;
			}
			if (email.indexOf('@') !== -1) {
				var e = email.split('@');
				return '<span>' + e[0] + '</span><span>' + '@' + e[1] + '</span>';
			} else {
				return email;
			}

		};
	}

	AgentListItemController.$inject = ['$scope'];

	angular.module('KimaMain').controller("AgentListItemController", AgentListItemController);

})();